export default "__VITE_ASSET__BxEhjYzZ__"